<script>
export const group = 'Bottom'
export const reuseComponent = true
</script>

<script setup>
import { onMounted, ref } from 'vue'
import { colors } from '../../../tailwindTheme.config.js'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import ContentBar from './shared/ContentBar.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const colorScheme = { backgroundColor: colors.q.cr.red.primary, color: colors.q.cr.red.darker }

const timelineContentBar = ref(null)
const timelineContentBarOut = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'ContentItem' }).add(timelineContentBar)
})

const { onDisappear } = useDisappearable()
onDisappear(() => gsapTimeline({ name: 'ContentItem - End' }).add(timelineContentBarOut.value()))
</script>

<template>
  <ContentBar
    :title="item.properties.title"
    :body="item.properties.body"
    :image="item.properties.image"
    :colorScheme="colorScheme"
    :backgroundAnimation="EFLoopAudioLevels02"
    @timeline="timelineContentBar = $event"
    @timelineOut="timelineContentBarOut = $event"
  />
</template>
